import { Box, Grid } from "@mui/material";
import { SharedTableEstadoVacio, type ControlSharedTabla } from "../../../shared/table";
import type { FilaInventario, SeleccionInventario } from "../types/catalogoInventario.types";
import type { AccionesInventario, TextosInventario } from "./CatalogoInventarioColumnas";
import { InventarioTarjeta } from "./InventarioTarjeta";

interface Props {
    control: ControlSharedTabla<FilaInventario>;
    acciones: AccionesInventario;
    seleccion: SeleccionInventario;
    textos: Pick<TextosInventario, "ver" | "editar" | "activar" | "desactivar" | "yaTieneQr">;
    textoDesactivado: string;
    textoSinStock: string;
    mensajeVacio: string;
}

export const CatalogoInventarioCuadricula = ({
    control,
    acciones,
    seleccion,
    textos,
    textoDesactivado,
    textoSinStock,
    mensajeVacio,
}: Props): JSX.Element => {
    const filas = control.tabla.getRowModel().rows;

    if (filas.length === 0) {
        return <SharedTableEstadoVacio mensaje={mensajeVacio} />;
    }

    return (
        <Box sx={{ p: 2 }}>
            <Grid container spacing={2}>
                {filas.map((fila) => (
                    <Grid item xs={12} sm={6} md={4} lg={3} key={fila.id}>
                        <InventarioTarjeta
                            fila={fila.original}
                            acciones={acciones}
                            seleccion={seleccion}
                            textos={textos}
                            textoDesactivado={textoDesactivado}
                            textoSinStock={textoSinStock}
                        />
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};
